import { Box, Text } from "@chakra-ui/react";
import { Meta } from "../../../components/Meta/Meta";
import { AccordionItem } from "../../../components/AccordionItem/AccordionItem";

export const FAQ = () => {
  return (
    <Box maxWidth="50rem" marginX="auto" paddingY="2rem">
      <Meta>
        <title>Green Flag - FAQ</title>
      </Meta>
      <Box
        as="h2"
        fontFamily="league-gothic"
        color="brand.green.dark"
        textAlign="left"
        paddingX="2rem"
        fontSize="3rem"
        marginBottom="1.5rem"
      >
        FAQ
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        paddingX="2rem"
      >
        <AccordionItem
          title="Do you provide ways to stay in touch with people I meet?"
          borderTop="1px solid"
          borderColor="brand.green.dark"
          paddingY="1rem"
        >
          <Text
            fontSize="1rem"
            marginTop="1rem"
            maxWidth="45rem"
            color="brand.green.dark"
          >
            Yes! After each event, you'll get access to our matching platform
            and be able to see everyone who attended. You can invite others to
            connect, and if the interest is mutual, we'll share whatever contact
            information you choose—no pressure, no awkward guessing.
          </Text>
        </AccordionItem>
        <AccordionItem
          title="What is the cancellation or refund policy?"
          borderTop="1px solid"
          borderColor="brand.green.dark"
          paddingY="1rem"
        >
          <Text
            fontSize="1rem"
            marginTop="1rem"
            maxWidth="45rem"
            color="brand.green.dark"
          >
            We understand that plans can change! If you need to cancel your
            registration, you can receive a full refund as long as you cancel at
            least 48 hours before the event. Unfortunately, we're unable to
            offer refunds for cancellations made within 48 hours of the event.
            This helps us maintain a great balance of attendees and cover venue
            costs. Thanks for your understanding! If we need to cancel an event
            for any reason, you will receive a full refund.
          </Text>
        </AccordionItem>
        <AccordionItem
          title="Are Green Flag events inclusive and LGBTQ+ friendly?"
          borderTop="1px solid"
          borderColor="brand.green.dark"
          paddingY="1rem"
        >
          <Text fontSize="1rem" marginTop="1rem" color="brand.green.dark">
            Our events are designed to be inclusive and welcoming to adults 21+,
            backgrounds, and interests. Specific events may cater to certain age
            groups or demographics, but we aim to create spaces where everyone
            feels comfortable.
          </Text>
        </AccordionItem>
        <AccordionItem
          title="What is your Code of Conduct?"
          borderTop="1px solid"
          borderColor="brand.green.dark"
          paddingY="1rem"
        >
          <Box marginTop="1rem" maxWidth="45rem">
            <Text fontSize="1rem" fontWeight="bold" color="brand.green.dark">
              Respect and Consideration
            </Text>
            <Text fontSize="1rem" marginBottom="1rem" color="brand.green.dark">
              Treat everyone you meet with kindness and courtesy. Respect
              personal boundaries, and remember that everyone is here to have a
              positive experience.
            </Text>

            <Text fontSize="1rem" fontWeight="bold" color="brand.green.dark">
              No Ghosting Policy
            </Text>
            <Text fontSize="1rem" marginBottom="1rem" color="brand.green.dark">
              If you connect with someone at an event, communicate openly and
              considerately after the social. Ghosting is a no-go—we're all
              about fostering genuine and respectful connections.
            </Text>

            <Text fontSize="1rem" fontWeight="bold" color="brand.green.dark">
              Inclusivity Over Exclusivity
            </Text>
            <Text fontSize="1rem" marginBottom="1rem" color="brand.green.dark">
              If you're in a group, make an effort to include anyone who came
              solo. No cliques, no competitive energy—just great conversations!
            </Text>

            <Text fontSize="1rem" fontWeight="bold" color="brand.green.dark">
              Zero Tolerance for Inappropriate Behavior
            </Text>
            <Text fontSize="1rem" marginBottom="1rem" color="brand.green.dark">
              Respectful conduct only: Any form of harassment, unwelcome
              behavior, or disrespect will not be tolerated. Attendees engaging
              in such actions will be immediately removed from the event and
              permanently banned from future events.
            </Text>
          </Box>
        </AccordionItem>
      </Box>
    </Box>
  );
};
